module.exports = __webpack_public_path__ + "img/germany-leukaemia-female.9aa2ccc1.png";